export default __webpack_public_path__ + "static/media/cirun-yaml.8e4978b4.png";